import { Button, Card, Checkbox, FormGroup, H6, InputGroup, MenuItem, ProgressBar, Switch } from '@blueprintjs/core';
import React, { useEffect, useState } from 'react';
import { AiOutlineRocket } from 'react-icons/ai';
import { FiLogIn } from 'react-icons/fi';
import { useHistory } from "react-router-dom";
import { Select } from "@blueprintjs/select";
import { FiArrowLeft } from 'react-icons/fi';

import { SignIn as ContextSignIn } from '../../Context';
import apiAdonis from '../../Services/adonis';
import { Empresa, Logon } from '../../Services/Controllers';
import { NotificacaoInterna } from '../../Services/Notification';
import { CPF } from '../../Themes/TextFormat';
import { Objeto } from '../../Services/Models';
import Logo from '../../Assets/Images/SingIn/Logo.png'

import { Container, Form, Checkbox1 } from './style';
import viewModel from './viewModel';
import Email from '../../Themes/TextFormat/Email';
import { api } from '../ConfigDePara/Services/api';
import { ForgotPassword } from '..';
import { Controller } from '../Menu';

const View: React.FC<viewModel> = (viewModel) => {
    /* #region  Variáveis  */
    const [getLoginComEmail, setLoginComEmail] = useState<boolean>(false);
    const [getLogin, setLogin] = useState<string>("");
    const [getSenha, setSenha] = useState<string>("");
    const [getMostrarSenha, setMostrarSenha] = useState<boolean>(false)
    const [getLembrarSenha, setLembrarSenha] = useState<boolean>(false);
    const [getItemPickerGrupoDeEmpresas, setItemPickerGrupoDeEmpresas] = useState<{ id: number, descricao: string, empresas: Array<Objeto.Empresa> }>();
    const [getListaPickerGrupoDeEmpresas, setListaPickerGrupoDeEmpresas] = useState<Array<{ id: number, descricao: string, empresas: Array<Objeto.Empresa> }>>([]);
    const PickerGrupoDeEmpresas = Select.ofType<{ id: number, descricao: string, empresas: Array<Objeto.Empresa> }>();
    const [getLoginEfetuado, setLoginEfetuado] = useState<{ Progresso?: number, Resultado?: boolean }>({ Progresso: undefined, Resultado: undefined });
    const History = useHistory();
    /* #endregion */

    /* #region  Funções  */
    /* Sobre esta função *//**
     * Valida os dados digitados e tenta efetuar o login do usuário
     **/


    async function EfetuarLogin(): Promise<any> {

        if (!getLogin) {
            NotificacaoInterna.ExibirNotificacao("Email não preenchido", "Informe o email", NotificacaoInterna.TipoDeNotificacao.Erro);
            return false;
        }
        if (Email.TextoValido(getLogin) == false) {
            NotificacaoInterna.ExibirNotificacao("Email inválido!", "Verifique se o email digitado é válido.", NotificacaoInterna.TipoDeNotificacao.Alerta);
            return false;
        }
        if (!getSenha) {
            NotificacaoInterna.ExibirNotificacao("Senha vazia", "É necessário digitar a senha!", NotificacaoInterna.TipoDeNotificacao.Alerta);
            return false;
        }

        try {
            await apiAdonis.post('/sessaoUsuarios', {
                email: getLogin,
                password: getSenha
            }).then(async results => {
                if (results.status === 200) {
                    if (results.data.user.status_user) {
                        NotificacaoInterna.ExibirNotificacao("Seja bem vindo!", "Faça um bom uso de nossa solução 😉.", NotificacaoInterna.TipoDeNotificacao.Sucesso, () => setLoginEfetuado({ Progresso: undefined, Resultado: undefined }));
                        localStorage.setItem("token", results.data.token.token);
                        localStorage.setItem("username", results.data.user.username);
                        localStorage.setItem("avatar", results.data.user.avatar);
                        localStorage.setItem("user", JSON.stringify(results.data.user));
                        if (results.data.user.emp_perms.find((emp_perm: {cd_emp: number} | null) => emp_perm?.cd_emp === 4)) {
                            History.push("/Menu/Analytics/Desembolso");
                        }
                        else if (results.data.user.emp_perms.find((emp_perm: {cd_emp: number} | null) => emp_perm?.cd_emp === 1)) {
                            History.push("/Menu/Analytics/Mapas");
                        } else {
                            History.push("/Menu");
                        }
                        window.location.reload();
                        return true;
                    }
                    else {
                        NotificacaoInterna.ExibirNotificacao("Usuário sem permissão", "Seu usuário não possui permissão para acessar a aplicação.", NotificacaoInterna.TipoDeNotificacao.Erro, () => setLoginEfetuado({ Progresso: undefined, Resultado: undefined }));
                    }
                }
            })
        }
        catch (e) {
            NotificacaoInterna.ExibirNotificacao("Erro", "Login ou senha incorretos, tente novamente!", NotificacaoInterna.TipoDeNotificacao.Erro, () => setLoginEfetuado({ Progresso: undefined, Resultado: undefined }));
            return false;
        }


    };

    useEffect(() => {
        async function componentDidMount() { }
        componentDidMount();
    }, []);

    return (
        <Container>
            <Form>
                <img src={Logo} alt="Logo One+" width="200px" />
                <h2>Analytics</h2>
                <h6>Faça Login para acessar os Dashboards</h6>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <InputGroup id="Email" placeholder="Email" value={getLogin}
                        onChange={async (event: React.FormEvent<HTMLInputElement>) => await setLogin((event.currentTarget.value).trim())} />
                    <div style={{ display: "flex", alignItems: "flex-end" }}>
                        <InputGroup id="Senha" placeholder="Senha" type="password" value={getSenha}
                            onChange={async (event: React.FormEvent<HTMLInputElement>) => await setSenha(event.currentTarget.value)} />
                        {/* <Button onClick={() => {setMostrarSenha(!getMostrarSenha)}} icon={ getMostrarSenha == true ? "eye-open" : "eye-off" } color="black" style={{position: "absolute", marginLeft: "256px", flex: 1, background:"transparent",border: "0px solid black" , outline:"none", width:"20px", height: "32px", boxShadow:"none"}}/> */}
                    </div>
                </div>
                <div style={{ display: "flex", width: "286px", justifyContent: "flex-end", alignItems: 'center' }}>
                    {/* <div style={{display:"flex", justifyContent:"space-between", alignItems: 'center'}}>
                             <Checkbox checked = {getLembrarSenha}  onChange= {() => {setLembrarSenha(!getLembrarSenha)}}></Checkbox>
                            <Checkbox1>Lembrar minha senha</Checkbox1>
                        </div> */}
                    <a onClick={() => Controller.AcessarForgotPassword(History)} id="Forgot_Password">Esqueci minha senha</a>
                </div>
                <div>
                    <Button type="submit" intent="primary" onClick={EfetuarLogin} id="Submit">Entrar</Button>
                    {/* {getLoginEfetuado.Progresso &&
                            <ProgressBar animate={true} stripes={true} value={getLoginEfetuado.Progresso}
                                intent={getLoginEfetuado.Resultado == undefined ? "none" : (getLoginEfetuado.Resultado == true ? "success" : "danger")}>
                            </ProgressBar>} */}
                </div>
                <div style={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
                    <h5>Não tem uma conta?</h5>
                    <a href="/SignUp">Cadastrar-se</a>
                </div>
            </Form>
        </Container>
    );
    /* #endregion */
};

export default View;